export default __webpack_public_path__ + "static/media/help.ecaa45a6.svg";